import {Config} from "../config";

export const getAvatarUrl = (id?: string) => {
    return `${Config.API_URL}/avatars/${id}`;
}